import {
  uploadComboImg,
  getComboProducts,
  registerCombo,
  getCombo,
  getComboById,
  deleteCombo,
  updateCombo,
} from "@/api";
import router from "@/router";
import { i18n } from "../../main";
const state = {
  comboType: "",
  idcombo: "",
  combos: [],
  combosLoading: false,

  currentStep: 1,

  basicInformation: {},
  basicInformationCompleted: false,

  description: {},
  descriptionCompleted: false,

  images: {},
  uploading: false,
  progress: 0,
  imagesCompleted: false,

  products: [],
  itens: [],
  cart: [],
  finalProducts: [],
  productsToFind: [],
  productsCompleted: false,
  productsLoading: false,
  modalAddProduct: false,
  modalCart: false,

  payload: {},
};
const getters = {
  getComboType: state => state.comboType,
  getIdCombo: state => state.idcombo,
  combos: state => state.combos,
  combosLoading: state => state.combosLoading,

  getCurrentStep: state => state.currentStep,

  getBasicInformation: state => state.basicInformation,
  basicInformationCompleted: state => state.basicInformationCompleted,

  getDescription: state => state.description,
  descriptionCompleted: state => state.descriptionCompleted,

  getImages: state => state.images,
  getProgress: state => state.progress,
  isUploading: state => state.uploading,
  imagesCompleted: state => state.imagesCompleted,

  getProducts: state => state.products,
  getCart: state => state.cart,
  getItens: state => state.itens,
  getFinalProducts: state => state.finalProducts,
  productsToFind: state => state.productsToFind,
  productsCompleted: state => state.productsCompleted,
  productsLoading: state => state.productsLoading,
  modalAddProduct: state => state.modalAddProduct,
  modalCart: state => state.modalCart,

  getPayload: state => state.payload,
};
const actions = {
  toggleCartModal({ commit }) {
    commit("modalCart");
  },

  setTypeCombo({ commit }, type) {
    commit("setComboType", type);
  },

  saveBasicInformation({ commit, getters }, basicInformation) {
    const {
      initDate,
      initHour,
      endDate,
      endHour,
      description,
      description_en,
      description_es,
      status,
      address,
      country,
      state,
      city,
      quantity,
    } = basicInformation;

    const info = {
      dthr_inicio: initDate + " " + initHour,
      dthr_termino: endDate + " " + endHour,
      descricao: `<pt_BR>${description}</pt_BR><en_US>${description_en}</en_US><es_ES>${description_es}</es_ES>`,
      status: status,
      end_local: address,
      end_pais: country,
      end_estado: state?.iso || state,
      end_cidade: city,
      qtd_max: quantity,
    };
    commit("setStep", getters.getCurrentStep + 1);
    commit("setBasicInformation", info);
    commit("setBasicInformationCompleted", true);
  },

  saveDescription({ commit, getters }, description) {
    const formatedDescription = `<pt_BR>${description.description_pt_br}</pt_BR><en_US>${description.description_en_us}</en_US><es_ES>${description.description_es_es}</es_ES>`;
    commit("setStep", getters.getCurrentStep + 1);
    commit("setDescription", formatedDescription);
    commit("setDescriptionCompleted", true);
  },

  async uploadImages({ commit }, images) {
    commit("setUploading", true);
    try {
      const response = await uploadComboImg(images, {
        onUploadProgress: progressEvent => {
          commit(
            "setProgress",
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        },
      });
      commit("setUploading", false);
      return response.data.url;
    } catch (error) {
      commit("setUploading", false);
      console.log(error);
    }
  },

  async getCombos({ commit }, params) {
    commit("setCombosLoading", true);
    try {
      const response = await getCombo(params);
      commit("setCombos", response.data);
      commit("setCombosLoading", false);
    } catch (error) {
      console.log(error);
      commit("setCombosLoading", false);
    }
  },

  async getComboById({ commit }, idcombo) {
    try {
      const response = await getComboById(idcombo);
      const { descricao, descritivo } = response.data;
      const basicInfo = {
        initDate: response.data.dthr_inicio.substring(0, 10),
        initHour: response.data.dthr_inicio.substring(11, 16),
        endDate: response.data.dthr_termino.substring(0, 10),
        endHour: response.data.dthr_termino.substring(11, 16),
        description: descricao.substring(
          descricao.indexOf("<pt_BR>") + 7,
          descricao.indexOf("</pt_BR>")
        ),
        description_en: descricao.substring(
          descricao.indexOf("<en_US>") + 7,
          descricao.indexOf("</en_US>")
        ),
        description_es: descricao.substring(
          descricao.indexOf("<es_ES>") + 7,
          descricao.indexOf("</es_ES>")
        ),
        status: response.data.status,
        address: response.data.end_local,
        country: response.data.end_pais,
        state: response.data.end_estado,
        city: response.data.end_cidade,
        quantity: response.data.qtd_max,
      };

      const description = {
        description_pt_br: descritivo.substring(
          descritivo.indexOf("<pt_BR>") + 7,
          descritivo.indexOf("</pt_BR>")
        ),
        description_en_us: descritivo.substring(
          descritivo.indexOf("<en_US>") + 7,
          descritivo.indexOf("</en_US>")
        ),
        description_es_es: descritivo.substring(
          descritivo.indexOf("<es_ES>") + 7,
          descritivo.indexOf("</es_ES>")
        ),
      };

      const images = JSON.parse(response.data.imagens);

      const imagesTransformed = Object.keys(images).map(key => {
        return {
          type: key,
          src: images[key],
        };
      });

      const products = JSON.parse(response.data.produtos);

      commit("setUpdateInfo", {
        basicInfo,
        imagesTransformed,
        description,
        products,
        idcombo,
      });
    } catch (error) {
      console.log(error);
    }
  },

  saveImages({ commit, getters }, images) {
    commit("setStep", getters.getCurrentStep + 1);
    commit("setImages", images);
    commit("setImagesCompleted", true);
  },

  async getProductsCombo({ commit }) {
    commit("setProductsLoading", true);
    try {
      const response = await getComboProducts();
      commit("setProducts", response.data);
      commit("setProductsLoading", false);
    } catch (error) {
      commit("setProductsLoading", false);
      console.log(error);
    }
  },
  addCart({ commit }, product) {
    const { itens, productInCart } = product;

    commit("setItens", itens);
    commit("setCart", productInCart);
  },
  addCartEdit({ commit }, product) {
    commit("setCartEdit", product);
  },
  removeAllProductsFromCart({ commit }) {
    commit("setRemoveAllProducts", []);
  },
  removeProductFromCart({ commit, getters }, product) {
    const itensFiltered = getters.getItens.filter(
      item => item.idproduto !== product.idproduto
    );
    const cartFiltered = getters.getCart.filter(
      item => item.idproduto !== product.idproduto
    );
    commit("setRemoveProduct", cartFiltered, itensFiltered);
  },
  saveProducts({ commit, getters }) {
    const infoAnalytics = getters.storeInfo;

    const { google_analytics, google_ads, google_tag_manager, facebook_pixel } =
      infoAnalytics;
    const transformedProduct = {
      loja: getters.storeSequencial.toString(),
      slug: getters.storeSlug,
      idprodutos: [],
      idproduto_variacoes: [],
      qtd: [],
      qtd_variacao: [],
      preco_prod: [],
      preco_var: [],
      slug_prod: [],
      slug_var: [],
      google_analytics,
      google_ads,
      google_tag_manager,
      facebook_pixel,
    };
    let total = 0;
    getters.getCart.map(item => {
      if (item?.quantityPossibilities?.length > 0) {
        item.idproduto_variacao.forEach(idprod_var => {
          transformedProduct.idproduto_variacoes.push({
            idproduto_variacao: idprod_var,
          });
        });
        transformedProduct.slug_var.push(item.slug);
        item?.quantityPossibilities.forEach(variation => {
          if (variation.quantity > 0) {
            transformedProduct.qtd_variacao.push(variation.quantity);
            transformedProduct.preco_var.push(variation.variationPrice);
            total += variation.variationPrice * variation.quantity;
            if (variation?.variations) {
              const idproduto_variacao =
                transformedProduct.idproduto_variacoes.find(
                  idprod_variacao =>
                    idprod_variacao?.idproduto_variacao ===
                    variation?.idproduto_variacao
                );

              idproduto_variacao.idvariacao_produto =
                variation?.variations[0]?.idvariacao_produto;
            }
          }
        });
      } else {
        transformedProduct.idprodutos.push(item.idproduto);
        transformedProduct.qtd.push(item.quantityIfOnlyQuantity);
        transformedProduct.preco_prod.push(item.newPrice);
        transformedProduct.slug_prod.push(item.slug);
        total += item.newPrice * item.quantityIfOnlyQuantity;
      }

      return transformedProduct, total;
    });
    transformedProduct.idprodutos = transformedProduct.idprodutos.join(",");
    transformedProduct.idproduto_variacoes = JSON.stringify(
      transformedProduct.idproduto_variacoes
    );
    transformedProduct.qtd = transformedProduct.qtd.join(",");
    transformedProduct.qtd_variacao = transformedProduct.qtd_variacao.join(",");
    transformedProduct.preco_prod = transformedProduct.preco_prod.join(",");
    transformedProduct.preco_var = transformedProduct.preco_var.join(",");
    transformedProduct.slug_prod = transformedProduct.slug_prod.join(",");
    transformedProduct.slug_var = transformedProduct.slug_var.join(",");

    const arrayProducts = [transformedProduct];
    const produtos = JSON.stringify(arrayProducts);

    commit("setFinalProducts", { produtos });
    commit("setProductsCompleted", true);
    commit("setPayload", total);

    if (getters.getComboType === "new") {
      this.dispatch("saveCombo");
    } else {
      this.dispatch("updateComboById");
    }
  },
  async saveCombo({ getters }) {
    try {
      await registerCombo(getters.getPayload);
      this.dispatch(
        "showSnackbarSuccess",
        i18n.t("events.combos.register-combo-success")
      );
      router.push("/combos");
      this.dispatch("getCombos");
    } catch (error) {
      console.error(error);
    }
  },
  async updateComboById({ getters }) {
    try {
      await updateCombo(getters.getPayload, getters.getIdCombo);
      this.dispatch(
        "showSnackbarSuccess",
        i18n.t("events.combos.register-combo-success")
      );
      router.push("/combos");
      this.dispatch("getCombos");
    } catch (error) {
      console.error(error);
    }
  },
  async removeCombo(context, idcombo) {
    try {
      await deleteCombo(idcombo);
      this.dispatch(
        "showSnackbarSuccess",
        i18n.t("events.combos.remove-combo-success")
      );
      this.dispatch("getCombos");
    } catch (error) {
      console.error(error);
      this.dispatch(
        "showSnackbarError",
        i18n.t("events.combos.remove-combo-error")
      );
    }
  },
  toggleProductAddModal({ commit }) {
    commit("modalAddProduct");
  },
  backStep({ commit, getters }) {
    commit("setStep", getters.getCurrentStep - 1);
  },

  cleanState({ commit }) {
    commit("cleanAllStates");
  },
};
const mutations = {
  modalAddProduct: state => (state.modalAddProduct = !state.modalAddProduct),
  modalCart: state => (state.modalCart = !state.modalCart),

  setComboType(state, type) {
    state.comboType = type;
  },
  setCombos(state, data) {
    state.combos = data;
  },

  setCombosLoading(state, bool) {
    state.combosLoading = bool;
  },

  setStep(state, step) {
    state.currentStep = step;
  },
  //setters basic infos
  setBasicInformation(state, data) {
    state.basicInformation = data;
  },
  setBasicInformationCompleted(state, bool) {
    state.basicInformationCompleted = bool;
  },

  //setters description infos
  setDescription(state, data) {
    const info = {
      descritivo: data,
    };
    state.description = info;
  },
  setDescriptionCompleted(state, bool) {
    state.descriptionCompleted = bool;
  },

  //setters images cards and highlights
  setImages(state, data) {
    const imagesTransformed = data.reduce((acc, item) => {
      acc[item.type] = item.src;
      return acc;
    }, {});
    const jsonImgs = JSON.stringify(imagesTransformed);
    state.images = { imagens: jsonImgs };
  },

  setUploading(state, bool) {
    state.uploading = bool;
  },
  setProgress(state, progress) {
    state.progress = progress;
  },
  setImagesCompleted(state, bool) {
    state.imagesCompleted = bool;
  },

  //setters combo - products
  setItens(state, data) {
    state.itens = [...state.itens, ...data];
  },
  setCart(state, data) {
    const previewCartIndex = state.cart.findIndex(
      item => item.idproduto === data.idproduto
    );

    if (previewCartIndex === -1) {
      state.cart.push(data);
    } else {
      state.cart.splice(previewCartIndex, 1, data);
    }
  },
  setCartEdit(state, data) {
    state.cart = data;
  },
  setRemoveProduct(state, data) {
    state.cart = data;
    state.itens = data;
  },
  setRemoveAllProducts(state, data) {
    state.cart = data;
    state.itens = data;
  },
  setProducts(state, data) {
    state.products = data;
  },
  setFinalProducts(state, data) {
    state.finalProducts = data;
  },
  setProductsCompleted(state, bool) {
    state.productsCompleted = bool;
  },
  setProductsLoading(state, bool) {
    state.productsLoading = bool;
  },
  setPayload(state, total) {
    state.payload = {
      valor: total,
      ...state.basicInformation,
      ...state.description,
      ...state.images,
      ...state.finalProducts,
    };
  },
  setUpdateInfo(state, data) {
    state.basicInformation = data.basicInfo;
    state.images = data.imagesTransformed;
    state.description = data.description;
    state.productsToFind = data.products;
    state.idcombo = data.idcombo;
  },
  cleanAllStates(state) {
    (state.currentStep = 1),
      (state.basicInformation = {}),
      (state.basicInformationCompleted = false),
      (state.description = {}),
      (state.descriptionCompleted = false),
      (state.images = {}),
      (state.imagesCompleted = false),
      (state.products = []),
      (state.itens = []),
      (state.cart = []),
      (state.finalProducts = []),
      (state.productsCompleted = false),
      (state.productsLoading = false),
      (state.modalAddProduct = false),
      (state.modalCart = false),
      (state.payload = {});
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
